<template>
  <popup-layout title="명함신청" :is-show="isShow" width="80vw" max-width="600">
    <template v-slot:content>
      <v-row>
        <field-input title="직책" cols="6">
          <v-text-field
            v-model="position"
            outlined hide-details dense
            background-color="white"
            :readonly="isDetail"
          />
        </field-input>
        <field-input title="이름" cols="6">
          <v-text-field
              v-model="memberNm"
              outlined hide-details dense
              background-color="white"
              :readonly="isDetail"
          />
        </field-input>
        <field-input title="등록번호" cols="6">
          <v-text-field
              v-model="loanBrokerNo"
              outlined hide-details dense
              background-color="grey lighten-4"
              disabled
          />
        </field-input>
        <field-input title="연락처" cols="6">
          <v-text-field
              v-model="mobile"
              outlined hide-details dense
              background-color="white"
              :readonly="isDetail"
          />
        </field-input>
        <field-input title="이메일" cols="6">
          <v-text-field
              v-model="email"
              outlined hide-details dense
              background-color="white"
              :readonly="isDetail"
          />
        </field-input>
        <field-input title="FAX" cols="6">
          <v-text-field
              v-model="fax"
              outlined hide-details dense
              background-color="white"
              :readonly="isDetail"
          />
        </field-input>
        <field-input title="장수" cols="6">
          <v-select
            v-model="quantity"
            :items="quantityList"
            item-text="name"
            item-value="cd"
            outlined hide-details dense
            background-color="white"
            :readonly="isDetail"
          />
        </field-input>
        <field-input title="메모" cols="1">
          <v-text-field
              v-model="note"
              outlined hide-details dense
              background-color="white"
              :readonly="isDetail"
              :placeholder="isDetail ? '' : '요청사항을 입력해주세요.(없을 시 미입력)'"
          />
        </field-input>
      </v-row>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn v-if="!isDetail" class="button save" outlined @click="isCardSignup">
          신청
        </v-btn>
        <v-btn class="button delete" outlined @click="close">
          닫기
        </v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import {mapGetters} from "vuex";
import {axiosInstance} from "@/util/AxiosModule";
import store from "@/store";

export default {
  name: "BusinessCardSignup",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "selectData", "popupType"],
  data() {
    return {
      memberNm: "",
      loanBrokerNo: "",
      mobile: "",
      email: "",
      fax: "",
      quantity: 500,
      quantityList: [
        { name: "500", cd: 500 },
        { name: "1000", cd: 1000 },
        { name: "1500", cd: 1500 }
      ],
      position: "대출상담사",
      note: ""
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData"
    }),
    isDetail() {
      return this.popupType === "detail";
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        if (this.popupType === "create") {
          this.memberNm = this.userData.memberNm;
          this.loanBrokerNo = this.userData.loanBrokerNo;
          this.mobile = this.userData.telNum;
          this.email = this.userData.email;
        } else if (this.popupType === "detail") {
          this.getCardDetail();
        }
      }
    }
  },
  methods: {
    isCardSignup() {
      this.showConfirm({
        message: "명함을 신청하시겠습니까?",
        successCallback: () => {
          this.cardSignup();
        }
      })
    },
    async cardSignup() {
      const address = "서울특별시 성동구 성수동1가 13-214, 동진아이티타워 제1층 제109호";
      const tel = "02-764-3030";
      const deliveryAddress = "인천시 서구 청라동 202-3 청라더리브티아모 지식산업센터 966호";

      const businessCardRequest = {
        quantity: this.quantity,          // 장수
        position: this.position,          // 직책
        name: this.memberNm,              // 이름
        loanBrokerNo: this.loanBrokerNo,  // 모집인번호(등록번호)
        mobile: this.mobile,              // 핸드폰
        email: this.email,                // 이메일
        address: address,                 // 주소
        tel: tel,                         // 전화
        fax: this.fax,                    // FAX
        deliveryAddress: deliveryAddress, // 배송지
        note: this.note,                  // 비고
      };

      try {
        await axiosInstance.post("/private/certificate/request", businessCardRequest, {
          params: {
            reqId: store.getters["login/memberId"],
            reqNote: "명함신청",
            certificateType: this.selectData.value
          }
        }).then(() => {
          this.showAlert({
            message: "명함신청이 완료되었습니다.",
            successCallback: () => {
              this.setDefaultData();
              this.close();
              this.$emit("refresh");
            }
          })
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async getCardDetail() {
      try {
        const { data } = await axiosInstance.get("/private/certificate/info", {
          params: {
            certificateId: this.selectData.certificateId,
            memberId: store.getters["login/memberId"]
          }
        });
        const cardData = data.businessCardRequest;

        this.position = cardData.position;
        this.memberNm = cardData.name;
        this.loanBrokerNo = cardData.loanBrokerNo;
        this.mobile = cardData.mobile;
        this.email = cardData.email;
        this.fax = cardData.fax;
        this.quantity = cardData.quantity;
        this.note = cardData.note;
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    setDefaultData() {
      this.memberNm = "";
      this.loanBrokerNo = "";
      this.mobile = "";
      this.email = "";
      this.fax = "";
      this.quantity = 500;
      this.position = "대출상담사";
      this.note = "";
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>